/* eslint-disable camelcase */
import type { AxiosInstance } from 'axios'
import { Carrier } from '~/carrier/Carrier'

interface ServiceRequestParamsDto {
  mail_id: string
  thing_id: string
  task_id: string
  signature: string
}

interface ServiceRequestBodyDto {
  first_name: string | null
  last_name: string | null
  email: string
  practice: string
  street: string | null
  zip: string | null
  city: string | null
  country: string | null
  place_id: string | null
  device_name: string | null
  device_model: string | null
  device_sn: string | null
  sp_name: string | null
  sp_city: string | null
  sp_contact_person: string | null
  sp_email: string | null
  sp_place_id: string | null
}

interface ServiceRequestDataDto extends ServiceRequestBodyDto {
  address: string | null
}

interface ServiceRequestMessageDto {
  message?: string
}

export class ServiceRequestCarrier extends Carrier {
  constructor(api: AxiosInstance) {
    super(api, 'service_request')
  }

  public get(
    params: ServiceRequestParamsDto
  ): Promise<{ data: ServiceRequestDataDto & ServiceRequestMessageDto }> {
    return this.api.get(this.path, { params })
  }

  public post(
    params: ServiceRequestParamsDto,
    body: ServiceRequestBodyDto
  ): Promise<{ data: ServiceRequestMessageDto }> {
    return this.api.post(this.path, body, { params })
  }
}
